export class TotalizadorDetalhes {

    public id: number;
    public nome: string;
    public faturamento = 0.;
    public maoDeObra = 0.;
    public horasVendidas = 0.;
    public horasTrabalhadas = 0.;
    public valorTotal: any;

     constructor(id: number, nome: string) {
         this.id = id;
         this.nome = nome;
     }


}
